<div class="c-grab-pnr__action t-tiny-pack auto-grab-pnr" *ngIf="isGrabPnrActive || isRefreshPnrActive">
  <ng-container *ngIf="isGrabPnrActive && (grabType !== GRAB_PNR_TYPE.REFRESH)">
    <ng-container *ngIf="stage===PNR_STAGES.DEFAULT || stage===PNR_STAGES.GRAB">
      <button *ngIf="!isBkgPage" class="a-btn a-btn--secondary" (click)="onClickGrab()"> + Grab Flight</button>
      <button *ngIf="isBkgPage" class="a-link-btn c-dropdown-menu__btn" (click)="onClickGrab()">
        <svg class="a-icon u-mr u-x1.25"><use xlink:href="#products--flight"></use></svg>
        Grab Flight
      </button>
    </ng-container>
    <ng-container *ngIf="stage===PNR_STAGES.GRAB_COMPLETE || stage===PNR_STAGES.CHANGE">
      <div class="a-loz a-loz--muted c-grab-pnr__label" *ngIf="grabType !== GRAB_PNR_TYPE.BOOKING || GRAB_PNR_TYPE.QUOTE">
        <span class="u-rmr">{{selectedPnrNumber | surfTextCase: 'upper'}}</span>
        <button class="a-link-btn s6" *ngIf="!isDP" (click)="onClickRemove()">
          <svg class="a-icon">
            <use xlink:href="#close"></use>
          </svg>
        </button>
      </div>

      <button class="a-btn a-btn--secondary" (click)="onClickChange()">
        <svg class="a-icon u-rmr">
          <use xlink:href="#edit"></use>
        </svg>Change PNR / Trip ID</button>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isRefreshPnrActive && (grabType === GRAB_PNR_TYPE.REFRESH)">
    <button class="a-link-btn a-link-btn--primary" (click)="onClickRefresh()">
      <svg class="a-icon u-rmr">
        <use xlink:href="#refresh"></use>
      </svg>
      Refresh PNR
    </button>
  </ng-container>

</div>
<div  class="o-modal" [ngClass]="{'is-active': showGrabPnrModal}" id="grab-pnr--pnr-id-modal">
  <div class="o-modal__content c-add-manual-item_modal">
    <div class="o-modal__inner-header">
      <button class="a-btn a-btn--link o-modal__inner-close" (click)="onClickCancel()">
        <svg class="a-icon o-modal__close-icon">
          <use xlink:href="#close"></use>
        </svg>
      </button>
      <button class="aa-btn a-btn--light o-modal__back-btn" (click)="onClickCancel()">
        <svg class="a-icon u-mr">
          <use xlink:href="#previous"></use>
        </svg>
        Back
      </button>
    </div>
    <div  class="o-modal__body">
      <div class="c-add-manual-item">
        <div class="c-add-manual-item__header">
          <h3 class="t-3 c-add-manual-item__header-title">Grab your flight</h3>
        </div>
        <surf-grab-flight-price-details
          [stepStatus]="stepHandler?.grabPriceMethodComponent"
          [isDP]="isDP"
          [isRefine] = "isRefine"
          (emitGrabPriceMethod)="getGrabPriceMethod($event)"
          (stepStatusOutput)="processStepCompletion($event)"
        ></surf-grab-flight-price-details>
        <surf-grab-pnr-details
          [stepStatus]="stepHandler?.grabPNRComponent"
          [properties]="pnrProperty"
          [componentValue]="pnrValues"
          [disabled]="disableInputs"
          [error]="externalError"
          [isDP] = "isDP"
          [isSabre] = "isSabre"
          [msg]="invalidErrorMsg"
          [defaultGDS] = "defaultGDS"
          [emitOnKeyUp]="true"
          [wrapperView]="false"
          (usePNRPriceRecordOut)="checkValue($event)"
          (onValueChangeOut)="onValueChange($event)"
          (setValidInputOut)="setValidInput($event)"
        ></surf-grab-pnr-details>
      </div>
      <div class="c-add-manual-item__footer">
        <button class="a-btn a-btn--default u-mr auto-grab-pnr-close" (click)="onClickCancel()">Cancel</button>
        <button class="a-btn a-btn--primary auto-grab-pnr-search" id="GrabPNRBtnID"
                (click)="onClickSearchPNR()"
                [disabled]="disableGrbBtn"
                [ngClass]="{'is-disabled' : disableGrbBtn , 'is-loading': isContinueButtonLoaderActive}"
        >Grab Flight</button>
      </div>
    </div>

  </div>
</div>

<div *ngIf="false" class="o-modal" [ngClass]="{'is-active': showGrabPnrModal}" id="grab-pnr--pnr-id-modal_old">

  <div class="o-modal__content pnr-modal" [ngClass]="{'surf-msg-box surf-msg-box--info': showPNRisSameDialog}">
    <div [hidden]="showPNRisSameDialog" class="o-modal__body ">
      <div class="o-modal__inner-header">
        <button class="a-btn a-btn--link o-modal__inner-close" (click)="onClickCancel()">
          <svg class="a-icon o-modal__close-icon">
            <use xlink:href="#close"></use>
          </svg>
        </button>
        <button class="a-btn a-btn--light o-modal__back-btn u-visible-sm" (click)="onClickCancel()">
          <svg class="a-icon u-mr">
            <use xlink:href="#previous"></use>
          </svg>
          Back
        </button>
      </div>
      <div class="pnr-modal__header">
        <div class="pnr-modal__header-details">
          <h3 class="pnr-modal__header-title t2">Grab PNR</h3>
          <p class="pnr-modal__header-sub-title">Please enter valid PNR ID to search flight criteria</p>
        </div>
      </div>
      <div class="pnr-modal__body t-mini-pack">

        <div class="pnr-modal__inner-section u-mb2+">
          <div class="pnr-modal__row">
            <div class="pnr-modal__item default-gds {{defaultGDS}}">
              <surf-multi-field-input
                [properties]="pnrProperty"
                [componentValue]="pnrValues"
                [title]="'PNR ID'"
                [disabled]="disableInputs"
                [error]="externalError"
                [msg]="invalidErrorMsg"
                [emitOnKeyUp]="true"
                [wrapeprView]="false"
                [isCapital]="true"
                [isPNR]="true"
                [ratioOne]="'1'"
                [ratioTwo]="'3'"
                (emitValues)="onValueChange($event)"
                (isValid)="setValidInput($event)">
              </surf-multi-field-input>

              <label *ngIf="isDP" class="a-checkbox u-rmt u-block">
                <input type="checkbox" class="a-checkbox__check" [disabled]="isSabre" (change)="checkValue($event)" [checked]="usePNRPriceRecord">
                <span class="a-checkbox__label">Use PNR price record</span>
              </label>

            </div>
            <div class="c-booking-summery__loading u-ml-" *ngIf="disableInputs"></div>
          </div>
        </div>

      </div>
      <div class="pnr-modal__footer">
        <button class="a-btn a-btn--default auto-grab-pnr-close" (click)="onClickCancel()">Cancel</button>
        <button class="a-btn a-btn--primary auto-grab-pnr-search"
                (click)="onClickSearchPNR()"
                [disabled]="disableInputs"
                [ngClass]="{'is-disabled' : disableInputs , 'is-loading': isContinueButtonLoaderActive}"
        >Search</button>
      </div>
    </div>
    <div *ngIf="showPNRisSameDialog" class="o-modal__body">
      <div class="pnr-modal__header">
        <div class="pnr-modal__header-details">
          <div class="surf-msg-box__header">
            <svg class="a-icon surf-msg-box__icon surf-msg-box--info">
              <use xlink:href="#info"></use>
            </svg>
            <h3 class="pnr-modal__header-title t2">PNR already exists</h3>
          </div>
          <p class="pnr-modal__header-sub-title">This PNR is opened in the current booking. Would you like to refresh the PNR?</p>
        </div>
<!--        <div class="pnr-modal__header-icon">-->
<!--          <svg class="a-icon" (click)="onClickCancel()">-->
<!--            <use xlink:href="#close"></use>-->
<!--          </svg>-->
<!--        </div>-->
      </div>
      <div class="pnr-modal__footer">
        <button class="a-btn a-btn--default" (click)="showPNRisSameDialog = false">Cancel</button>
        <button class="a-btn a-btn--primary"
                (click)="onClickOkPNRisSameDialog()"
        >Ok</button>
      </div>
    </div>
  </div>

</div>

<div class="o-modal" [ngClass]="{'is-active': showTravellerChangesModal}" id="grab-pnr--traveller-comparison-modal">

  <div class="o-modal__content c-compare-pnr">

    <div class="o-modal__body">
      <div class="o-modal__inner-header">
        <button class="a-btn a-btn--link o-modal__inner-close" (click)="onClickCancelTraveller()">
          <svg class="a-icon o-modal__close-icon">
            <use xlink:href="#close"></use>
          </svg>
        </button>
        <button class="a-btn a-btn--light o-modal__back-btn u-visible-sm" (click)="onClickCancelTraveller()">
          <svg class="a-icon u-mr">
            <use xlink:href="#previous"></use>
          </svg>
          Back
        </button>
      </div>

      <div class="c-compare-pnr__header" id="errorPopupHeaderLocator">
        <div class="surf-msg-box__header">
          <ng-container *ngIf="grabPnrBookingModule?.showErrorMessage">
            <svg class="a-icon surf-msg-box__icon">
              <use xlink:href="#exclamation"></use>
            </svg>
            <h3 class="surf-msg-box__title">Warning</h3>
          </ng-container>
          <ng-container *ngIf="!grabPnrBookingModule?.showErrorMessage">
            <svg class="a-icon surf-msg-box__icon">
              <use xlink:href="#info"></use>
            </svg>
            <h3 class="surf-msg-box__title">PNR Details</h3>
          </ng-container>
        </div>
        <div class="surf-msg-box__body" *ngIf="grabPnrBookingModule?.showErrorMessage">
          <span class="surf-msg-box__body-content">Looks like we have a guest detail difference here. Please take a look and confirm following changes.</span>
        </div>
      </div>

      <h4 class="t5 c-compare-pnr__title">Flight details</h4>

      <div class="c-compare-pnr__content">

        <div class="c-compare-pnr__section" *ngFor="let sector of flightGrabPnrResult?.sectors; let index = index">
          <div class="c-compare-pnr__row c-compare-pnr__row--header">
            <div class="c-compare-pnr__item">
              <h5 class="t5 c-compare-pnr__item-title">
                <span title="{{sector?.departure | airport | async}}">{{ sector?.departure }}</span> - <span
                  title="{{sector?.arrival | airport | async}}">{{ sector?.arrival }}</span></h5>
            </div>
          </div>

          <div class="c-compare-pnr__row">
            <div class="c-compare-pnr__item">
              <span class="lbl c-compare-pnr__item-lbl">Departure Date & time</span>
              <div class="c-compare-pnr__item-name">
                {{sector.departureDateTime | surfDatePipe: DATE_TIME_FORMAT}}
              </div>
            </div>
            <div class="c-compare-pnr__item">
              <span class="lbl c-compare-pnr__item-lbl">Departure - Arrival</span>
              <div class="c-compare-pnr__item-name">
                {{sector?.from?.cityName}} - {{sector?.to?.cityName}}
              </div>
            </div>
          </div>
        </div>

      </div>

      <h4 class="t5 c-compare-pnr__title">Passengers</h4>

      <div class="c-compare-pnr__content">

        <div class="c-compare-pnr__section">
          <div class="c-compare-pnr__row c-compare-pnr__row--header">
            <div class="c-compare-pnr__item">
              <span class="a-loz a-loz--muted c-compare-pnr__tag">Booking</span>
            </div>
            <div class="c-compare-pnr__item">
              <span class="a-loz a-loz--important c-compare-pnr__tag">PNR</span>
            </div>
          </div>

          <div class="c-compare-pnr__row" *ngFor="let item of grabPnrBookingModule?.matchingTravellers; let i = index;">

            <div class="c-compare-pnr__item auto-booking-traveller">
              <ng-container *ngIf="item?.bkgTraveller">
                <span class="lbl c-compare-pnr__item-lbl">{{ getPaxTypeDisplayText(item.bkgTraveller) }}</span>
                <div class="c-compare-pnr__item-name">
                  <span>{{item.bkgTraveller.profile?.title | surfTextCase: 'title'}}.</span>
                  <span>{{item.bkgTraveller.profile?.firstName | surfTextCase: 'title'}}</span>
                  <span *ngIf="item.bkgTraveller.profile?.middleName && item.bkgTraveller.profile?.middleName.length > 0">{{item.bkgTraveller.profile?.middleName | surfTextCase: 'title'}}</span>
                  <span>{{item.bkgTraveller.profile?.lastName | surfTextCase: 'title'}}</span>
                </div>

                <!--show dob comparison for infants-->
                <ng-template [ngIf]="item.bkgTraveller?.profile?.type == 'I'">
                  <div class="c-compare-pnr__item-text" *ngIf="item.diffs?.hasMatch && !item?.diffs?.dateOfBirth">
                    <span class="ts-strong">Date of birth</span>
                    {{item.bkgTraveller.profile?.dob ? (item.bkgTraveller.profile?.dob | surfDatePipe: DATE_FORMAT) : 'N/A'}}
                  </div>

                  <div class="c-compare-pnr__item-text" *ngIf="item.diffs?.hasPrimaryMatch && !item?.diffs?.dateOfBirth">
                    <span class="ts-strong">Date of birth</span>
                    {{item.bkgTraveller.profile?.dob ? (item.bkgTraveller.profile?.dob | surfDatePipe: DATE_FORMAT) : 'N/A'}}
                  </div>
                </ng-template>

                <!--show age comparison for children-->
                <ng-template [ngIf]="item.bkgTraveller?.profile?.type == 'C'">
                  <div class="c-compare-pnr__item-text" *ngIf="item.diffs?.hasMatch && !item?.diffs?.age">
                    <span class="ts-strong">Age</span>
                    {{item.bkgTraveller?.profile?.age}}
                  </div>
                  <div class="c-compare-pnr__item-text" *ngIf="item.diffs?.hasPrimaryMatch && !item?.diffs?.age">
                    <span class="ts-strong">Age</span>
                    {{item.bkgTraveller?.profile?.age}}
                  </div>


                  <!--TODO-dob known ???-->
                </ng-template>

                <div class="c-compare-pnr__item-text" *ngIf="item.diffs?.hasMatch && !item?.diffs?.phoneNumber">
                  <span class="ts-strong">Phone number</span>
                  {{getTelephoneNumber(item.bkgTraveller)}}
                </div>

                <div class="c-compare-pnr__item-text" *ngIf="checkEmail( item.bkgTraveller, item.pnrTraveller)">
                  <span class="ts-strong">E-mail</span>
                  {{getEmail(item.bkgTraveller)}}
                </div>

                <div class="c-compare-pnr__item-text m-info-set" *ngIf="item.diffs?.hasMatch && !item?.diffs?.freqFlyer">
                  <span class="ts-strong">Frequent flyer number{{item.bkgTraveller.profile?.frequentFlyerNumbers?.length > 0 ? 's' : ''}}</span>
                  {{(!item.bkgTraveller.profile?.frequentFlyerNumbers || item.bkgTraveller.profile?.frequentFlyerNumbers.length === 0) ? 'N/A' : ''}}
                  <ng-container *ngIf="item.bkgTraveller.profile?.frequentFlyerNumbers.length > 0">
                    <span *ngFor="let frqFlyer of item.bkgTraveller.profile?.frequentFlyerNumbers">{{frqFlyer?.airline | airline | async}} - {{frqFlyer?.flyerNo}}</span>
                  </ng-container>
                </div>

              </ng-container>
            </div>

            <div class="c-compare-pnr__item auto-pnr-traveller">
              <ng-container *ngIf="item?.pnrTraveller">
                <span class="lbl c-compare-pnr__item-lbl">{{ getPaxTypeDisplayText(item.pnrTraveller) }}</span>
                <div class="c-compare-pnr__item-name">
                  <span [ngClass]="{'c-compare-pnr__item-diff' : (item.diffs?.hasMatch && !item.diffs?.title)}">
                    {{item.pnrTraveller.profile?.title | surfTextCase: 'title'}}<span *ngIf="item.pnrTraveller.profile?.title">.</span>
                  </span>
                  <span
                    [ngClass]="{'c-compare-pnr__item-diff' : (item.diffs?.hasMatch && !item.diffs?.firstName)}">{{item.pnrTraveller.profile?.firstName | surfTextCase: 'title'}}</span>
                  <span
                    [ngClass]="{'c-compare-pnr__item-diff' : (item.diffs?.hasMatch && !item.diffs?.middleName && item.pnrTraveller.profile?.middleName.length > 0)}">{{item.pnrTraveller.profile?.middleName | surfTextCase: 'title'}}</span>
                  <span
                    [ngClass]="{'c-compare-pnr__item-diff' : (item.diffs?.hasMatch && !item.diffs?.lastName)}">{{item.pnrTraveller.profile?.lastName | surfTextCase: 'title'}}</span>
                </div>

                <ng-template [ngIf]="item.pnrTraveller?.profile?.type == 'I'">
                  <div class="c-compare-pnr__item-text" *ngIf="item.diffs?.hasMatch && !item?.diffs?.dateOfBirth">
                    <span class="ts-strong">Date of birth</span>
<!--                    <span class="c-compare-pnr__item-diff">{{item.pnrTraveller.profile?.dob ? (item.pnrTraveller.profile?.dob | surfDatePipe: DATE_FORMAT) : 'N/A'}}</span>-->
                    {{item.pnrTraveller.profile?.dob ? (item.pnrTraveller.profile?.dob | surfDatePipe: DATE_FORMAT) : 'N/A'}}
                  </div>
                  <div class="c-compare-pnr__item-text" *ngIf="item.diffs?.hasPrimaryMatch && !item?.diffs?.dateOfBirth">
                    <span class="ts-strong">Date of birth</span>
                    <span class="c-compare-pnr__item-diff">{{item.pnrTraveller.profile?.dob ? (item.pnrTraveller.profile?.dob | surfDatePipe: DATE_FORMAT) : 'N/A'}}</span>
                  </div>
                </ng-template>

                <ng-template [ngIf]="item.pnrTraveller?.profile?.type == 'C'">
                  <div class="c-compare-pnr__item-text" *ngIf="item.diffs?.hasMatch && !item?.diffs?.age">
                    <span class="ts-strong">Age</span>
                    <span class="c-compare-pnr__item-diff">{{item.pnrTraveller.profile?.age}}</span>
                  </div>
                  <div class="c-compare-pnr__item-text" *ngIf="item.diffs?.hasPrimaryMatch && !item?.diffs?.age">
                    <span class="ts-strong">Age</span>
                    <span class="c-compare-pnr__item-diff">{{item.pnrTraveller.profile?.age}}</span>
                  </div>
                </ng-template>

                <div class="c-compare-pnr__item-text" *ngIf="item.diffs?.hasMatch && !item?.diffs?.phoneNumber">
                  <span class="ts-strong">Phone number</span>
                  <span class="c-compare-pnr__item-diff">{{getTelephoneNumber(item.pnrTraveller)}}</span>
                </div>

                <div class="c-compare-pnr__item-text" *ngIf="checkEmail( item.bkgTraveller, item.pnrTraveller)">
                  <span class="ts-strong">E-mail</span>
                  <span
                    [ngClass]="{'c-compare-pnr__item-diff' : (item.diffs?.hasMatch && !item.diffs?.email)}">{{getEmail(item.pnrTraveller)}}</span>
                </div>

                <div class="c-compare-pnr__item-text m-info-set" *ngIf="item.diffs?.hasMatch && !item?.diffs?.freqFlyer">
                  <span class="ts-strong">Frequent flyer number{{item.pnrTraveller.profile?.frequentFlyerNumbers?.length > 0 ? 's' : ''}}</span>
                  <span class="c-compare-pnr__item-diff">{{(!item.pnrTraveller.profile?.frequentFlyerNumbers || item.pnrTraveller.profile?.frequentFlyerNumbers.length === 0) ? 'N/A' : ''}}</span>
                  <ng-container *ngIf="item.pnrTraveller.profile?.frequentFlyerNumbers?.length > 0">
                    <span class="c-compare-pnr__item-diff" *ngFor="let frqFlyer of item.pnrTraveller.profile?.frequentFlyerNumbers">{{frqFlyer.airline | airline | async}} - {{frqFlyer.flyerNo}}</span>
                  </ng-container>
                </div>

              </ng-container>

            </div>

          </div>
        </div>

      </div>

      <div class="o-modal__footer t-mini-pack">
        <button class="a-btn a-btn--trinity u-mr" (click)="onClickCancelTraveller()">Cancel</button>
        <button class="a-btn a-btn--primary auto-grab-pnr-accept" (click)="onClickAcceptTravellerChanges()">Accept</button>
      </div>
    </div>
  </div>

</div>

<div class="o-modal" [ngClass]="{'is-active': showRefreshChangesModal && !isManual}" id="refresh-pnr--comparison-modal">

  <div class="o-modal__content c-compare-status_modal">

    <div class="o-modal__inner-header">
      <button class="a-btn a-btn--link o-modal__inner-close" (click)="closeRefreshPNRModal()">
        <svg class="a-icon o-modal__close-icon">
          <use xlink:href="#close"></use>
        </svg>
      </button>
      <button class="a-btn a-btn--light o-modal__back-btn" (click)="closeRefreshPNRModal()">
        <svg class="a-icon u-mr">
          <use xlink:href="#previous"></use>
        </svg>
        Back
      </button>
    </div>

    <div class="o-modal__body">

      <div class="c-compare-status">

        <div class="c-compare-status__header">
          <div class="surf-msg-box__header">
            <svg class="a-icon surf-msg-box__icon">
              <ng-container *ngIf="!refreshError">
                <use *ngIf="refreshUpdateAvailable" xlink:href="#exclamation"></use>
                <use *ngIf="!refreshUpdateAvailable" xlink:href="#checked"></use>
              </ng-container>
              <use *ngIf="refreshError" xlink:href="#error"></use>
            </svg>
            <h3 class="surf-msg-box__title" *ngIf="!refreshError">Warning</h3>
            <h3 class="surf-msg-box__title" *ngIf="refreshError">Refresh PNR Failed</h3>
          </div>
          <div class="surf-msg-box__body">
            <span class="surf-msg-box__body-content">
              <ng-container *ngIf="!refreshError">
                <ng-template ngFor let-msg [ngForOf]="refreshChangeList">
                <span>{{msg}}</span><br>
                </ng-template>
            </ng-container>
            <span *ngIf="refreshError">{{refreshErrorMsg}}</span>
            </span>
          </div>
        </div>

        <div class="o-tabs" *ngIf="refreshUpdateAvailable">

          <div class="o-tabs__content c-compare-status__body">

            <!--Tab content item loop-->
            <ng-template ngFor let-fltItem [ngForOf]="itemWiseRefreshChanges" let-k="index">

              <div class="o-tabs__pane c-compare-status__tab" [ngClass]="{'is-active': fltItem?.active}" id="'#tab-'+{{k}}">

                <!--Tab content for 1 flight item-->
                <ng-container *ngIf="!refreshError"> <!--Show this block only if there are refresh changes and no errors-->

                  <!--Show only if flight changes available-->
                  <ng-container *ngIf="fltItem?.flightInfoChanged || fltItem?.sectorInfoChanged">

                    <div class="c-compare-status__content">

                      <h4 class="t5 c-compare-status__title">Flight details</h4>

                      <!--Main section -- Flight info changes-->
                      <div class="c-compare-status__section" *ngIf="fltItem?.flightInfoChanged">

                        <div class="c-compare-status__row c-compare-status__row--header">
                          <div class="c-compare-status__item">
                            <span class="a-loz a-loz--tertiary c-compare-status__tag">Booking</span>
                          </div>
                          <div class="c-compare-status__item">
                            <span class="a-loz a-loz--important c-compare-status__tag">PNR</span>
                          </div>
                        </div>

                        <!--General flight info-->
                        <ng-template ngFor let-fltChange [ngForOf]="fltItem?.refreshFlightInfoChanges" let-j="index">
                          <div class="c-compare-status__row">
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">{{fltChange.typeName}}</span>
                              <div class="c-compare-status__item-name">
                                <span *ngIf="fltChange.type === 'TTL'">{{formatDate(fltChange.bkgVal)}}</span>
                                <!--if TTL, format with date pipe-->
                                <span *ngIf="fltChange.type !== 'TTL'">{{fltChange.bkgVal}}</span>
                                <!--if not TTL, show as it is-->
                              </div>
                            </div>
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">{{fltChange.typeName}}</span>
                              <div class="c-compare-status__item-name">
                              <span class="c-compare-status__item-diff">
                                  <span *ngIf="fltChange.type === 'TTL'">{{formatDate(fltChange.pnrVal)}}</span>
                                  <span *ngIf="fltChange.type !== 'TTL'">{{fltChange.pnrVal}}</span>
                              </span>
                              </div>
                            </div>
                          </div>
                        </ng-template>

                      </div>

                      <!--Main section - Sector wise changes-->
                      <ng-template ngFor let-secKey [ngForOf]="fltItem?.refreshSectorInfoChangeKeys" let-i="index">
                        <div class="c-compare-status__section" [ngClass]="{'has-error': secKey?.split('~')[2] == 'R', 'is-added': secKey?.split('~')[2] == 'A'}">

                          <div class="c-compare-status__row c-compare-status__row--header">
                            <div class="c-compare-status__item">
                              <span class="a-loz a-loz--tertiary c-compare-status__tag" *ngIf="!fltItem?.flightInfoChanged && fltItem?.sectorInfoChanged && secKey?.split('~')[2] != 'R' && secKey?.split('~')[2] != 'A'">Booking</span>
                              <h5 class="t5 c-compare-status__item-title">
                                {{secKey?.split('~')[1]}}
                              </h5>
                            </div>
                            <div class="c-compare-status__item" *ngIf="!fltItem?.flightInfoChanged && fltItem?.sectorInfoChanged && secKey?.split('~')[2] != 'R' && secKey?.split('~')[2] != 'A'">
                              <span class="a-loz a-loz--important c-compare-status__tag">PNR</span>
                              <h5 class="t5 c-compare-status__item-title">
                                {{fltItem?.updatedPNRRoutes?.get(secKey)}}
                              </h5>
                            </div>
                          </div>

                          <ng-container *ngFor="let secChange of fltItem?.refreshSectorInfoChanges?.get(secKey)">

                            <div class="c-compare-status__row"
                                 *ngIf="secKey?.split('~')[2] != 'R' && secKey?.split('~')[2] != 'A'">

                              <div class="c-compare-status__item">
                                <span class="lbl c-compare-status__item-lbl">{{secChange.typeName}}</span>
                                <div class="c-compare-status__item-name">
                                  <span
                                    *ngIf="secChange.type === 'DEPDATE' || secChange.type === 'ARRDATE'">{{secChange.bkgVal | surfDatePipe: DATE_TIME_FORMAT}}</span>
                                  <span
                                    *ngIf="!(secChange.type === 'DEPDATE' || secChange.type === 'ARRDATE')">{{secChange.bkgVal}}</span>
                                </div>
                              </div>

                              <div class="c-compare-status__item">
                                <span class="lbl c-compare-status__item-lbl">{{secChange.typeName}}</span>
                                <div class="c-compare-status__item-name">
                                <span class="c-compare-status__item-diff">
                                    <span
                                      *ngIf="secChange.type === 'DEPDATE' || secChange.type === 'ARRDATE'">{{secChange.pnrVal | surfDatePipe: DATE_TIME_FORMAT}}</span>
                                    <span
                                      *ngIf="!(secChange.type === 'DEPDATE' || secChange.type === 'ARRDATE')">{{secChange.pnrVal}}</span>
                                </span>
                                </div>
                              </div>

                            </div>                <!--Sector change-->

                            <div class="c-compare-status__msg tc-important" *ngIf="secKey?.split('~')[2] == 'R'">
                              <svg class="a-icon u-rmr c-compare-status__msg-icon">
                                <use xlink:href="#exclamation"></use>
                              </svg>
                              This flight sector has been removed from this PNR
                            </div>  <!--Sector remove warning block-->

                            <div class="c-compare-status__msg tc-success" *ngIf="secKey?.split('~')[2] == 'A'">
                              <svg class="a-icon u-rmr c-compare-status__msg-icon">
                                <use xlink:href="#info"></use>
                              </svg>
                              This flight sector has been added to this PNR
                            </div>    <!--Sector add warning block-->

                          </ng-container>

                        </div>
                      </ng-template>

                    </div>

                  </ng-container>

                  <!--Main section -- Pax info changes - show only if available-->
                  <ng-container *ngIf="fltItem?.refreshPaxChanged">
                    <div class="c-compare-status__content">

                    <h4 class="t5 c-compare-status__title">Passengers</h4>

                    <div class="c-compare-status__section">

                      <div class="c-compare-status__row c-compare-status__row--header">
                        <div class="c-compare-status__item">
                          <span class="a-loz a-loz--tertiary c-compare-status__tag">Booking</span>
                        </div>
                        <div class="c-compare-status__item">
                          <span class="a-loz a-loz--important c-compare-status__tag">PNR</span>
                        </div>
                      </div>

                      <ng-template ngFor let-key [ngForOf]="fltItem?.refreshPaxChangeKeys" let-i="index">

                        <!--ROW for Pax [x]-->
                        <div class="c-compare-status__row fs-exclude">

                          <div class="c-compare-status__item"> <!--Booking value-->
                            <span class="lbl c-compare-status__item-lbl" *ngIf="(fltItem?.refreshPaxChanges?.get(key))[0]?.bkgVal">{{(fltItem?.refreshPaxChanges?.get(key))[0]?.paxType}}</span>

                            <ng-container *ngFor="let change of fltItem?.refreshPaxChanges?.get(key)">

                              <div class="c-compare-status__item-name" *ngIf="change.type === 'NAME' && change?.bkgVal">
                                <span>{{change?.bkgVal}}</span>
                              </div>

                              <div class="c-compare-status__item-text" *ngIf="change.type === 'DOB' && change?.bkgVal">
                                <span class="ts-strong">Date of birth</span>
                                {{getDate(change?.bkgVal) | surfDatePipe: DATE_FORMAT}}
                              </div>

                              <div class="c-compare-status__item-text" *ngIf="change.type === 'TP' && change?.bkgVal">
                                <span class="ts-strong">Phone number</span>
                                {{change?.bkgVal}}
                              </div>

                              <div class="c-compare-status__item-text" *ngIf="change.type === 'FFN' && change?.bkgVal">
                                <span class="ts-strong">Frequent flyer number</span>
                                {{change?.bkgVal}}
                              </div>

                              <div class="c-compare-status__item-text" *ngIf="change.type === 'CST' && change?.bkgVal">
                                <span class="ts-strong">Cost</span>
                                {{change?.bkgVal}}
                              </div>

                              <div class="c-compare-status__item-text" *ngIf="change.type === 'PRC' && change?.bkgVal">
                                <span class="ts-strong">Price</span>
                                {{change?.bkgVal}}
                              </div>

                            </ng-container>

                          </div>

                          <div class="c-compare-status__item"> <!--PNR value-->
                            <span class="lbl c-compare-status__item-lbl" *ngIf="(fltItem?.refreshPaxChanges?.get(key))[0]?.pnrVal">{{(fltItem?.refreshPaxChanges?.get(key))[0]?.paxType}}</span>

                            <ng-container *ngFor="let change of fltItem?.refreshPaxChanges?.get(key)">

                              <div class="c-compare-status__item-name" *ngIf="change.type === 'NAME' && change?.pnrVal">
                                <ng-container *ngFor="let nc of getNameChanges(change?.pnrVal)">
                                  <span [ngClass]="{'c-compare-status__item-diff': hasChange(nc)}">{{getValue(nc)}}</span>
                                </ng-container>
                              </div>

                              <div class="c-compare-status__item-text" *ngIf="change.type === 'DOB' && change?.pnrVal">
                                <span class="ts-strong">Date of birth</span>
                                <span [ngClass]="{'c-compare-status__item-diff': change?.changed}">{{getDate(change?.pnrVal) | surfDatePipe: DATE_FORMAT}}</span>
                              </div>

                              <div class="c-compare-status__item-text" *ngIf="change.type === 'TP' && change?.pnrVal">
                                <span class="ts-strong">Phone number</span>
                                <span [ngClass]="{'c-compare-status__item-diff': change?.changed}">{{change?.pnrVal}}</span>
                              </div>

                              <div class="c-compare-status__item-text" *ngIf="change.type === 'FFN' && change?.pnrVal">
                                <span class="ts-strong">Frequent flyer number</span>
                                <span [ngClass]="{'c-compare-status__item-diff': change?.changed}">{{change?.pnrVal}}</span>
                              </div>

                              <div class="c-compare-status__item-text" *ngIf="change.type === 'CST' && change?.pnrVal">
                                <span class="ts-strong">Cost</span>
                                <span [ngClass]="{'c-compare-status__item-diff': change?.changed}">{{change?.pnrVal}}</span>
                              </div>

                              <div class="c-compare-status__item-text" *ngIf="change.type === 'PRC' && change?.pnrVal">
                                <span class="ts-strong">Price</span>
                                <span [ngClass]="{'c-compare-status__item-diff': change?.changed}">{{change?.pnrVal}}</span>
                              </div>

                            </ng-container>

                          </div>

                        </div>
                        <!--ROW for Pax [x]-->

                      </ng-template>

                    </div>

                  </div>
                  </ng-container>

                  <!--Main section -- No changes indicator-->
                  <ng-container *ngIf="!(fltItem?.flightInfoChanged || fltItem?.sectorInfoChanged  || fltItem?.refreshPaxChanged)">
                  No refresh changes.
                  </ng-container>

                </ng-container>
                <!--Tab content for 1 flight item-->

              </div>

            </ng-template>

          </div>

          <div class="o-tabs__nav c-compare-status__tab-nav">
            <!--Tab nav item loop-->
            <ng-template ngFor let-fltItem [ngForOf]="itemWiseRefreshChanges" let-k="index">
              <a class="o-tabs__nav-item" [ngClass]="{'is-active': fltItem?.active}" (click)="onFlightItemTabClick(k)">
                {{fltItem?.name}}
              </a>
            </ng-template>
            <!--Tab nav item loop-->
          </div>

        </div>

      </div>

      <div class="o-modal__footer t-mini-pack">
        <ng-container *ngIf="!refreshError">
          <button class="a-btn a-btn--trinity u-mr" *ngIf="refreshUpdateAvailable" (click)="closeRefreshPNRModal()">Cancel</button>
          <button class="a-btn a-btn--primary"  *ngIf="updateAvailableMessage || refreshUpdateAvailable && !((paxTitleChangesAfterRefreshPNR || paxChangesOtherThanPaxTitlesAfterRefreshPNR) && !(hasFlightOrSectorInfoChangesAfterRefreshPNR || paxPriceChangesAfterRefreshPNR))" (click)="applyPNRChanges()" [ngClass]="{'is-disabled': refreshApplyNotAllowed}">Apply</button>
          <button class="a-btn a-btn--primary" *ngIf="(!updateAvailableMessage && !refreshUpdateAvailable) || !updateAvailableMessage && (paxTitleChangesAfterRefreshPNR || paxChangesOtherThanPaxTitlesAfterRefreshPNR) && !hasFlightOrSectorInfoChangesAfterRefreshPNR && !paxPriceChangesAfterRefreshPNR" (click)="closeRefreshPNRModal()">OK</button>
        </ng-container>
        <button class="a-btn a-btn--trinity u-mr" *ngIf="refreshError" (click)="closeRefreshPNRModal()">OK</button>
      </div>

    </div>

  </div>

</div>

<div class="o-modal" [ngClass]="{'is-active': showRefreshChangesModal && isManual}" id="manual-refresh-pnr--comparison-modal">

  <div class="o-modal__content c-compare-status_modal">

    <div class="o-modal__inner-header">
      <button class="a-btn a-btn--link o-modal__inner-close" (click)="closeRefreshPNRModal()">
        <svg class="a-icon o-modal__close-icon">
          <use xlink:href="#close"></use>
        </svg>
      </button>
      <button class="a-btn a-btn--light o-modal__back-btn" (click)="closeRefreshPNRModal()">
        <svg class="a-icon u-mr">
          <use xlink:href="#previous"></use>
        </svg>
        Back
      </button>
    </div>

    <div class="o-modal__body">

      <div class="c-compare-status">
        <div class="c-compare-status__header">
          <div class="surf-msg-box__header">
            <svg class="a-icon surf-msg-box__icon">
              <ng-container *ngIf="!refreshError">
                <use *ngIf="refreshUpdateAvailable" xlink:href="#exclamation"></use>
                <use *ngIf="!refreshUpdateAvailable" xlink:href="#checked"></use>
              </ng-container>
            </svg>
            <h3 class="surf-msg-box__title" *ngIf="!refreshError && !refreshUpdateAvailable">Warning</h3>
            <h3 class="surf-msg-box__title" *ngIf="!refreshError && refreshUpdateAvailable">Validate your flight details</h3>
            <h3 class="surf-msg-box__title" *ngIf="refreshError">Refresh PNR Failed</h3>
          </div>
          <div class="surf-msg-box__body">
            <span class="surf-msg-box__body-content">
              <ng-container *ngIf="!refreshError">
                <ng-template ngFor let-msg [ngForOf]="refreshChangeList">
                <span>{{msg}}</span><br>
                </ng-template>
              </ng-container>
              <span *ngIf="refreshError">{{refreshErrorMsg}}</span>
<!--              <span class="surf-msg-box__body-content">Looks like we have a guest detail difference here. Please take a look and confirm following changes.</span>-->
            </span>
          </div>
        </div>

        <div class="o-tabs" *ngIf="refreshUpdateAvailable">

          <div class="o-tabs__content c-compare-status__body">
            <!--Tab content item loop-->
            <ng-template ngFor let-fltItem [ngForOf]="itemWiseRefreshChanges" let-k="index">
            <div class="o-tabs__pane c-compare-status__tab" [ngClass]="{'is-active': fltItem?.active}" id="'#tab-'+{{k}}">

              <div class="c-compare-status__content">
                <h4 class="t5 c-compare-status__title">Flight details</h4>
                <!--Main section -- Flight info changes-->
                <div class="c-compare-status__section" *ngIf="fltItem?.flightInfoChanged">

                  <div class="c-compare-status__row c-compare-status__row--header">
                    <div class="c-compare-status__item">
                      <span class="a-loz a-loz--tertiary c-compare-status__tag">Booking</span>
                    </div>
                    <div class="c-compare-status__item">
                      <span class="a-loz a-loz--important c-compare-status__tag">PNR</span>
                    </div>
                  </div>

                  <!--General flight info-->
                  <ng-template ngFor let-fltChange [ngForOf]="fltItem?.refreshFlightInfoChanges" let-j="index">
                    <div class="c-compare-status__row">
                      <div class="c-compare-status__item">
                        <span class="lbl c-compare-status__item-lbl">{{fltChange.typeName}}</span>
                        <div class="c-compare-status__item-name">
                          <span *ngIf="fltChange.type === 'TTL'">{{formatDate(fltChange.bkgVal)}}</span>
                          <!--if TTL, format with date pipe-->
                          <span *ngIf="fltChange.type !== 'TTL'">{{fltChange.bkgVal}}</span>
                          <!--if not TTL, show as it is-->
                        </div>
                      </div>
                      <div class="c-compare-status__item">
                        <span class="lbl c-compare-status__item-lbl">{{fltChange.typeName}}</span>
                        <div class="c-compare-status__item-name">
                              <span class="c-compare-status__item-diff">
                                  <span *ngIf="fltChange.type === 'TTL'">{{formatDate(fltChange.pnrVal)}}</span>
                                  <span *ngIf="fltChange.type !== 'TTL'">{{fltChange.pnrVal}}</span>
                              </span>
                        </div>
                      </div>
                    </div>
                  </ng-template>

                </div>
                <!--Main section - Sector wise changes-->
              </div>
              <!--Show only if flight changes available-->
              <ng-container *ngIf="fltItem?.flightInfoChanged || fltItem?.sectorInfoChanged">
                <ng-template ngFor let-secKey [ngForOf]="fltItem?.refreshSectorInfoChangeKeys" let-i="index">
                  <div class="c-compare-status__content">
                    <h4 class="t5 c-compare-status__title">Segment {{i+1}}</h4>

                    <div class="c-compare-status__section" [ngClass]="{'has-error': secKey?.split('~')[2] == 'R', 'is-added': secKey?.split('~')[2] == 'A'}">

                    <div class="c-compare-status__row c-compare-status__row--header">
                      <div class="c-compare-status__item">
                        <span class="a-loz a-loz--tertiary c-compare-status__tag" *ngIf="!fltItem?.flightInfoChanged && fltItem?.sectorInfoChanged && secKey?.split('~')[2] != 'R' && secKey?.split('~')[2] != 'A'">Booking</span>
                        <h5 class="t5 c-compare-status__item-title">
                          {{secKey?.split('~')[1]}}
                        </h5>
                      </div>
                      <div class="c-compare-status__item" *ngIf="!fltItem?.flightInfoChanged && fltItem?.sectorInfoChanged && secKey?.split('~')[2] != 'R' && secKey?.split('~')[2] != 'A'">
                        <span class="a-loz a-loz--important c-compare-status__tag">PNR</span>
                        <h5 class="t5 c-compare-status__item-title">
                          {{fltItem?.updatedPNRRoutes?.get(secKey)}}
                        </h5>
                      </div>
                    </div>
                      <ng-container *ngIf="secKey?.split('~')[2] != 'R' && secKey?.split('~')[2] != 'A'">
                        <div class="c-compare-status__row">
                          <div class="c-compare-status__item">
                            <span class="lbl c-compare-status__item-lbl">Departure details</span>
                            <div class="c-compare-status__item-name">
                              <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure') ? (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure').bkgVal| airport:'getObject' | async)?.name +"&nbsp;("+ (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure').bkgVal)+")" : (flightDetailList[i]?.departure | airport:'getObject' | async)?.name +"&nbsp;(" +(flightDetailList[i]?.departure) +")"}}</span>
                              <span >,</span>
                              <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure Date & Time') ? (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure Date & Time').bkgVal| surfDatePipe: DATE_TIME_FORMAT ): (flightDetailList[i]?.departureDateTime | surfDatePipe: DATE_TIME_FORMAT) }}</span>
                            </div>
                          </div>
                          <div class="c-compare-status__item">
                            <span class="lbl c-compare-status__item-lbl">Departure details</span>
                            <div class="c-compare-status__item-name">
                              <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure') }">{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure') ? (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure').pnrVal| airport:'getObject' | async)?.name + "&nbsp;("  + (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure').pnrVal) +")" : (flightDetailList[i]?.departure | airport:'getObject' | async)?.name +"&nbsp;("+ (flightDetailList[i]?.departure) +")"}}</span>
                              <span >,&nbsp;</span>
                              <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure Date & Time') }">{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure Date & Time') ? (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure Date & Time').pnrVal| surfDatePipe: DATE_TIME_FORMAT ): (flightDetailList[i]?.departureDateTime | surfDatePipe: DATE_TIME_FORMAT) }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="c-compare-status__row">
                          <div class="c-compare-status__item">
                            <span class="lbl c-compare-status__item-lbl">Arrival details</span>
                            <div class="c-compare-status__item-name">
                              <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Destination') ? (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Destination').bkgVal| airport:'getObject' | async)?.name +"&nbsp;("+ (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Destination').bkgVal) +")": (flightDetailList[i]?.arrival | airport:'getObject' | async)?.name +"&nbsp;("+ (flightDetailList[i]?.arrival) +")"}}</span>
                              <span >,</span>
                              <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Arrival Date & Time') ? (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Arrival Date & Time').bkgVal| surfDatePipe: DATE_TIME_FORMAT ): (flightDetailList[i]?.arrivalDateTime | surfDatePipe: DATE_TIME_FORMAT) }}</span>
                            </div>
                          </div>
                          <div class="c-compare-status__item">
                            <span class="lbl c-compare-status__item-lbl">Arrival details</span>
                            <div class="c-compare-status__item-name">
                              <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Destination') }">{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Destination') ? (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Destination').pnrVal | airport:'getObject' | async)?.name +"&nbsp;(" + (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Destination').pnrVal) +")": (flightDetailList[i]?.arrival | airport:'getObject' | async)?.name +"&nbsp;("+ (flightDetailList[i]?.arrival) +")"}}</span>
                              <span >,</span>
                              <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Arrival Date & Time') }">{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Arrival Date & Time') ? (isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Arrival Date & Time').pnrVal| surfDatePipe: DATE_TIME_FORMAT ): (flightDetailList[i]?.arrivalDateTime | surfDatePipe: DATE_TIME_FORMAT) }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="c-compare-status__row">
                          <div class="c-compare-status__row-group">
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Airline</span>
                              <div class="c-compare-status__item-name">
                                <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Airline') ? ( isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Airline').bkgVal | airline | async ) : ( flightDetailList[i]?.airline | airline | async ) }}</span>
                              </div>
                            </div>
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Operating airline</span>
                              <div class="c-compare-status__item-name">
                                <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Operating Airline') ? ( isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Operating Airline').bkgVal | airline | async ) : ( flightDetailList[i]?.airlineOperator | airline | async ) }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="c-compare-status__row-group">
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Airline</span>
                              <div class="c-compare-status__item-name">
                                 <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Airline') }">
                                   <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Airline') ? ( isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Airline').pnrVal | airline | async ) : ( flightDetailList[i]?.airline | airline | async ) }}</span>
                                 </span>
                              </div>
                            </div>
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Operating airline</span>
                              <div class="c-compare-status__item-name">
                                 <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Operating Airline') }">
                                    <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Operating Airline') ? ( isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Operating Airline').pnrVal | airline | async ) : ( flightDetailList[i]?.airlineOperator | airline | async ) }}</span>
                                 </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="c-compare-status__row">
                          <div class="c-compare-status__row-group">
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Flight number</span>
                              <div class="c-compare-status__item-name">
                                <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Flight Number') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Flight Number').bkgVal : flightDetailList[i]?.flightNumber }}</span>
                              </div>
                            </div>
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Cabin class & Booking class</span>
                              <div class="c-compare-status__item-name">
                                <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Booking Class') ? flightDetailList[i]?.cabinClass +"/"+ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Booking Class').bkgVal :  flightDetailList[i]?.cabinClass +"/"+ flightDetailList[i]?.bookingClass  }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="c-compare-status__row-group">
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Flight number</span>
                              <div class="c-compare-status__item-name">
                                <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Flight Number') }">
                                  <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Flight Number') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Flight Number').pnrVal : flightDetailList[i]?.flightNumber }}</span>
                                </span>
                              </div>
                            </div>
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Cabin class & Booking class</span>
                              <div class="c-compare-status__item-name">
                                <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Booking Class') }">
                                  <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Booking Class') ? flightDetailList[i]?.cabinClass +"/"+ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Booking Class').pnrVal :  flightDetailList[i]?.cabinClass +"/"+ flightDetailList[i]?.bookingClass  }}</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="c-compare-status__row">
                          <div class="c-compare-status__row-group">
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Airline locator</span>
                              <div class="c-compare-status__item-name">
                                <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Airline Locator') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Airline Locator').bkgVal : flightDetailList[i]?.airlineLocator }}</span>
                              </div>
                            </div>
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Departure terminal</span>
                              <div class="c-compare-status__item-name">
                                <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure Terminal') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure Terminal').bkgVal : flightDetailList[i]?.departureTerminal }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="c-compare-status__row-group">
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Airline locator</span>
                              <div class="c-compare-status__item-name">
                                <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Airline Locator') }">
                                  <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Airline Locator') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Airline Locator').pnrVal : flightDetailList[i]?.airlineLocator }}</span>
                                </span>
                              </div>
                            </div>
                            <div class="c-compare-status__item">
                              <span class="lbl c-compare-status__item-lbl">Departure terminal</span>
                              <div class="c-compare-status__item-name">
                                <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure Terminal') }">
                                  <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure Terminal') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Departure Terminal').pnrVal : flightDetailList[i]?.departureTerminal }}</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="c-compare-status__row">
                          <div class="c-compare-status__item">
                            <span class="lbl c-compare-status__item-lbl">Arrival terminal</span>
                            <div class="c-compare-status__item-name">
                              <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Arrival Terminal') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Arrival Terminal').bkgVal : flightDetailList[i]?.arrivalTerminal }}</span>
                            </div>
                          </div>
                          <div class="c-compare-status__item">
                            <span class="lbl c-compare-status__item-lbl">Arrival terminal</span>
                            <div class="c-compare-status__item-name">
                            <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Arrival Terminal') }">
                              <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Arrival Terminal') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Arrival Terminal').pnrVal : flightDetailList[i]?.arrivalTerminal }}</span>
                            </span>
                            </div>
                          </div>
                        </div>
                        <div class="c-compare-status__row">
                          <div class="c-compare-status__item">
                            <span class="lbl c-compare-status__item-lbl">Baggage</span>
                            <div class="c-compare-status__item-name">
                              <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Baggage') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Baggage').bkgVal : flightDetailList[i]?.baggage }}</span>
                            </div>
                          </div>
                          <div class="c-compare-status__item">
                          <span class="lbl c-compare-status__item-lbl">Baggage</span>
                          <div class="c-compare-status__item-name">
                            <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Baggage') }">
                              <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Baggage') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Baggage').pnrVal : flightDetailList[i]?.baggage }}</span>
                            </span>
                          </div>
                        </div>
                        </div>
                        <div class="c-compare-status__row">
                          <div class="c-compare-status__item">
                            <span class="lbl c-compare-status__item-lbl">Equipment</span>
                            <div class="c-compare-status__item-name">
                              <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Equipment') ? isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Equipment').bkgVal : flightDetailList[i]?.equipment }}</span>
                            </div>
                          </div>
                          <div class="c-compare-status__item">
                            <span class="lbl c-compare-status__item-lbl">Equipment</span>
                            <div class="c-compare-status__item-name">
                            <span [ngClass]="{'c-compare-status__item-diff': isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Equipment') }">
                              <span >{{ isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Equipment') ?
                                ( isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Equipment').pnrVal.trim().length > 0 ?
                                  isChangeAvilable(fltItem?.refreshSectorInfoChanges?.get(secKey),'Equipment').pnrVal : "-") : flightDetailList[i]?.equipment }}</span>
                            </span>
                            </div>
                          </div>
                        </div>
                        <div class="c-compare-status__row">
                          <div class="c-compare-status__row-group" *ngFor="let repeat of [].constructor(2)">
                            <div class="c-compare-status__item">
                              <label class="a-radio is-disabled">
                                <input [checked]="!flightDetailList[i]?.isOutBound" class="a-radio__check"  type="radio"
                                       value="None">
                                <span class="a-radio__label">Inbound flight</span>
                              </label>
                            </div>
                            <div class="c-compare-status__item">
                              <label class="a-radio is-disabled">
                                <input [checked]="flightDetailList[i]?.isOutBound" class="a-radio__check"  type="radio" value="None">
                                <span class="a-radio__label">Outbound flight</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <div class="c-compare-status__msg tc-important" *ngIf="secKey?.split('~')[2] == 'R'">
                        <svg class="a-icon u-rmr c-compare-status__msg-icon">
                          <use xlink:href="#exclamation"></use>
                        </svg>
                        This flight sector has been removed from this PNR
                      </div>  <!--Sector remove warning block-->

                      <div class="c-compare-status__msg tc-success" *ngIf="secKey?.split('~')[2] == 'A'">
                        <svg class="a-icon u-rmr c-compare-status__msg-icon">
                          <use xlink:href="#info"></use>
                        </svg>
                        This flight sector has been added to this PNR
                      </div>    <!--Sector add warning block-->

                  </div>
                  </div>
                </ng-template>
              </ng-container>
            </div>
            </ng-template>

          </div>
          <div class="o-tabs__nav c-compare-status__tab-nav">
            <!--Tab nav item loop-->
            <ng-template ngFor let-fltItem [ngForOf]="itemWiseRefreshChanges" let-k="index">
              <a class="o-tabs__nav-item" [ngClass]="{'is-active': fltItem?.active}" (click)="onFlightItemTabClick(k)">
                {{fltItem?.name}}
              </a>
            </ng-template>
            <!--Tab nav item loop-->
          </div>
        </div>
      </div>
      <div class="o-modal__footer t-mini-pack">
        <ng-container *ngIf="!refreshError">
          <button class="a-btn a-btn--trinity u-mr" *ngIf="refreshUpdateAvailable" (click)="closeRefreshPNRModal()">Cancel</button>
          <button class="a-btn a-btn--primary"  *ngIf="updateAvailableMessage || refreshUpdateAvailable && !((paxTitleChangesAfterRefreshPNR || paxChangesOtherThanPaxTitlesAfterRefreshPNR) && !(hasFlightOrSectorInfoChangesAfterRefreshPNR || paxPriceChangesAfterRefreshPNR))" (click)="applyPNRChanges()" [ngClass]="{'is-disabled': refreshApplyNotAllowed}">Apply</button>
          <button class="a-btn a-btn--primary" *ngIf="(!updateAvailableMessage && !refreshUpdateAvailable) || !updateAvailableMessage && (paxTitleChangesAfterRefreshPNR || paxChangesOtherThanPaxTitlesAfterRefreshPNR) && !hasFlightOrSectorInfoChangesAfterRefreshPNR && !paxPriceChangesAfterRefreshPNR" (click)="closeRefreshPNRModal()">OK</button>
        </ng-container>
        <button class="a-btn a-btn--trinity u-mr" *ngIf="refreshError" (click)="closeRefreshPNRModal()">OK</button>
      </div>
    </div>
  </div>
</div>

<surf-message-box [title]="'Warning'" [cancelLabel]="'Cancel'" id="{{UPDATE_TRAVELLER_WARNING_MODAL_ID}}"
                  [active]="isMismatchDetailWarning" [hasConfirmButon]="true" [confirmLabel]="'OK'"
                  [type]="'error'" [svgName]="'exclamation'" (clickButton)="onClickContinueTraveller($event)">
  <span>Please note that the existing passenger details will not be updated with the GDS details</span>
</surf-message-box>

<surf-message-box [title]="'Refresh PNR failed'" [active]="refreshError" id="{{APPLY_CHANGES_ERROR_MODAL_ID}}"
                  [hasConfirmButon]="false" [hasCancelButton]="true" (clickButton)="refreshError = false;"
                  [cancelLabel]="'OK'"
                  [svgName]="'error'" [type]="'error'">
  <span >{{refreshErrorMsg}}</span>
</surf-message-box>

<surf-message-box [title]="'Error'" [active]="grabError" id="{{GRAB_PNR_ERROR_MODAL_ID}}"
                  [hasConfirmButon]="false" [hasCancelButton]="true" (clickButton)="grabError = false;"
                  [cancelLabel]="'OK'"
                  [svgName]="'error'" [type]="'error'">
  <span >{{grabErrorMsg}}</span>
</surf-message-box>

<surf-message-box [title]="'Booking update successful'" [active]="showApplyChangesModal" id="{{APPLY_CHANGES_SUCCESS_MODAL_ID}}"
                  [hasConfirmButon]="true" [hasCancelButton]="false" (clickButton)="reloadPage()"
                  [confirmLabel]="'Reload'"
                  [svgName]="'checked'" [type]="'success'">
  <span>Successfully updated the booking with PNR changes. Please reload the booking to continue.</span>
</surf-message-box>

<surf-message-box [title]="'Proceed to Grab PNR?'" [active]="showDPGrabWarning" id="{{DP_GRAB_PNR_WARNING_MODAL_ID}}"
                  [hasConfirmButon]="true" [hasCancelButton]="true" (clickButton)="initiateDPGrab($event)"
                  [confirmLabel]="'Proceed'"
                  [cancelLabel]="'Cancel'"
                  [svgName]="'exclamation'" [type]="'warning'">
  <span>Seems like you have already add some criteria, these will be reset if you proceed</span>
</surf-message-box>

<surf-message-box [title]="'PNR exists in another booking'"
                  id="{{PNR_ALREADY_EXISTS_IN_A_BOOKING_MODAL_ID}}"
                  [active]="PNRExistsInAnotherBookingMessageVisible"
                  [hasConfirmButon]="true"
                  [hasCancelButton]="true"
                  [confirmLabel]="'Continue'"
                  [cancelLabel]="'Cancel'"
                  (clickButton)="handlePNRExistsInAnotherBooking($event)"
                  [svgName]="'info'"
                  [type]="'info'"
>
  <span>{{surfModalDescription}}</span>
</surf-message-box>

<surf-message-box [title]="ENABLE_SURF_MC_GRAB ? 'Proceed to DP grab flow?' : 'Not available'" [active]="showDPGrabSwitchWarning" id="{{DP_GRAB_SWITCH_WARNING_MODAL_ID}}"
                  [hasConfirmButon]="ENABLE_SURF_MC_GRAB" [hasCancelButton]="true" (clickButton)="grabAndSwitchToDP($event)"
                  [confirmLabel]="'Proceed'"
                  [cancelLabel]="'Cancel'"
                  [svgName]="'exclamation'" [type]="'warning'">
<!--  FC-31415 : have to show different warning message with checking sabre or not-->
  <span *ngIf="ENABLE_SURF_MC_GRAB && !isSabre">Multiple validating carriers found. Would you like to grab this using the DP flow?</span>
  <span *ngIf="ENABLE_SURF_MC_GRAB && isSabre">Multiple price quotes found. Please use the DP flow to grab the PNR</span>
  <span *ngIf="!ENABLE_SURF_MC_GRAB">Multi Carrier grab is not available at the moment.</span>
  <label *ngIf="ENABLE_SURF_MC_GRAB" class="a-checkbox u-rmt u-block" [ngClass]="{'surf-checkbox--disabled is-disabled': disablePNRPriceRecord}">
    <input type="checkbox" class="a-checkbox__check" [disabled]="disablePNRPriceRecord" (change)="checkValue($event)" [checked]="usePNRPriceRecord">
    <span class="a-checkbox__label">Use PNR price record</span>
  </label>
</surf-message-box>

<surf-page-loader [show]="showLoader" [loaderType]="'cart'" [title]="loaderTitle" [onBody]="true">
  <div class="c-page-loader__text">
    <span class="c-page-loader__sub-text">Please wait for a few seconds</span>
  </div>
</surf-page-loader>
